import { Datasource, IDatasource } from 'utility-ts-orm';
import { APAlternatePlanNonExistingCourse } from '../builders/ap_alternate_plan_non_existing_course_builder';

export interface IAPAlternatePlanNonExistingCoursesDatasource extends IDatasource<APAlternatePlanNonExistingCourse> {}

angular.module('capability-ng-academic-planner').factory(
  'ngAPAlternatePlanNonExistingCoursesDatasource',
  (): IAPAlternatePlanNonExistingCoursesDatasource =>
    new Datasource<APAlternatePlanNonExistingCourse, {}>({
      builderType: APAlternatePlanNonExistingCourse,
      updateMode: 'merge'
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/alternate_plans/datasources/non_existing_courses_new_plan_datasource.ts